/******************************************** STYLING *********************************************/
const s = require('./auth-panel-root.scss');

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';
import {omit} from 'mad-utils/lib/react';

/**************************************** PROJECT MODULES *****************************************/
import {
    translate,
    CIFormInput,
    SmallText,
    VeryLargeText,
    CIFormInputProps,
} from '@canimmunize/core-imports';

/*************************************** TYPE DEFINITIONS *****************************************/
export interface CloseWindowMessageProps {
    disabled?: boolean;
    mergeClasses?: string | string[];
}

/******************************************** EXPORTS *********************************************/
/**
 * Custom CIFormInput used in signup pages with added focus/type handling
 */
export const SUFormInput = (
    props: {
        value: string;
        dataType: string;
        onChange: InputChangeHandler;
        type?: Html.InputElement.Types;
        setFocusedInput: InputChangeHandler;
        isFocused: boolean;
        noBottomMargin?: boolean;
    } & Partial<CIFormInputProps>
) => (
    <CIFormInput
        value={props.value || ``}
        onChange={props.onChange}
        type={props.type || `text`}
        onFocus={event => props.setFocusedInput(props.dataType as any)}
        mergeClasses={cn(props.isFocused ? `bbc-blue` : `bbc-light-gray`)}
        noBottomMargin={props.noBottomMargin}
        {...omit(props, [`value`, `dataType`, `isFocused`, `setFocusedInput`])}
    />
);

SUFormInput.displayName = `SUFormInput`;

/**
 * Display small-font message advising user that they may close the window,
 * if something isn't disabling its display
 * @param {boolean} disabled If true, don't display the component
 * @param {string|string[]} mergeClasses Additional CSS classes to apply to the
 *                                       text wrapping element
 */
export const CloseWindowMessage = ({disabled, mergeClasses}: CloseWindowMessageProps) => (
    <SmallText disabled={disabled} mergeClasses={mergeClasses} center>
        {`${translate('you_may_close_this_window').rmEndPunc}.`}
    </SmallText>
);

CloseWindowMessage.displayName = `CloseWindowMessage`;

/**
 *  Title text for auth panel card
 *  e.g. 'Login', 'Create Account'
 */
export const CardHeading = ({className, children}: {className?: string; children: string}) => (
    <VeryLargeText mergeClasses={className}>{children}</VeryLargeText>
);

CardHeading.displayName = `CardHeading`;

/**************************************** EXTERNAL EXPORTS ****************************************/
export * from '../../../util-components/util-components';
